'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onMessageReceived = undefined;

var _toJS = require('transmute/toJS');

var _toJS2 = _interopRequireDefault(_toJS);

var _PubNubMessageSerializer = require('conversations-schema/serializers/PubNubMessageSerializer');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _isCloseThreadMessage = require('conversations-schema/pubnub-message/operators/isCloseThreadMessage');

var _isTypingMessage = require('conversations-schema/pubnub-message/operators/isTypingMessage');

var _isFromVisitor = require('conversations-schema/pubnub-message/operators/isFromVisitor');

var _isContactAssociationMessage = require('conversations-schema/pubnub-message/operators/isContactAssociationMessage');

var _isOpenThreadMessage = require('conversations-schema/pubnub-message/operators/isOpenThreadMessage');

var _getUtk = require('conversations-schema/contact-association-metadata/operators/getUtk');

var _pubnubMessageSetters = require('conversations-schema/pubnub-message/operators/pubnubMessageSetters');

var _handleStoreMessagesCookie = require('../../post-message/actions/handleStoreMessagesCookie');

var _assignmentV2MessageReceived = require('../../actions/assignmentV2MessageReceived');

var _defaultMessageReceived = require('../../actions/defaultMessageReceived');

var _typingMessageReceived = require('../../typing-indicators/actions/typingMessageReceived');

var _chatMessageReceived = require('./chatMessageReceived');

var _closeThreadMessageReceived = require('./closeThreadMessageReceived');

var _getThreadByChannel = require('../../threads/selectors/getThreadByChannel');

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onMessageReceived = exports.onMessageReceived = function onMessageReceived(pubNubMessage) {
  return function (dispatch, getState) {
    var channel = pubNubMessage.channel,
        messageJson = pubNubMessage.message,
        timetoken = pubNubMessage.timetoken;

    var thread = (0, _getThreadByChannel.getThreadByChannel)(getState(), { channel: channel });
    var threadId = (0, _pubnubMessageGetters.getThreadId)(thread);

    var message = (0, _pubnubMessageSetters.setThreadId)(threadId, (0, _PubNubMessageSerializer.deserialize)({
      json: messageJson,
      channel: channel,
      timetoken: timetoken
    }));

    switch (true) {
      case (0, _messageTypeComparators.isInitialMessage)(message):
      case (0, _messageTypeComparators.isAutomatedChatMessage)(message):
      case (0, _isFromVisitor.isFromVisitor)(message):
      case (0, _isOpenThreadMessage.isOpenThreadMessage)(message):
        {
          // NOOP
          break;
        }

      case (0, _messageTypeComparators.isAssignmentMessageV2)(message):
        {
          dispatch((0, _assignmentV2MessageReceived.assignmentV2MessageReceived)(message, channel));
          break;
        }

      case (0, _isTypingMessage.isTypingMessage)(message):
        {
          dispatch((0, _typingMessageReceived.typingMessageReceived)(message));
          break;
        }

      case (0, _isContactAssociationMessage.isContactAssociationMessage)(message):
        {
          dispatch((0, _handleStoreMessagesCookie.handleStoreMessagesCookie)((0, _getUtk.getUtk)(message)));
          break;
        }

      case (0, _messageTypeComparators.isChatMessage)(message):
        {
          dispatch((0, _chatMessageReceived.chatMessageReceived)(message, channel));
          break;
        }

      case (0, _isCloseThreadMessage.isCloseThreadMessage)(message):
        {
          dispatch((0, _closeThreadMessageReceived.closeThreadMessageReceived)({ message: message, thread: thread }));
          break;
        }

      default:
        {
          window.Raven.captureMessage('DEFAULT_MESSAGE_RECEIVED', {
            extra: { message: (0, _toJS2.default)(message) },
            level: 'info'
          });
          dispatch((0, _defaultMessageReceived.defaultMessageReceived)(message, channel));
        }
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/actions/onMessageReceived.js
// module id = 322
// module chunks = 2 3